import { createSlice } from '@reduxjs/toolkit'

const initialState: 'ko' | 'en' = 'ko'

export const LanguageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setStoreLanguage: (state, action) => {
      return action.payload
    },
  },
})

export default LanguageSlice
export const { setStoreLanguage } = LanguageSlice.actions
